<template>
    <section id="garage-list-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <h2>
                        My Recommendation
                    </h2>
                    <div class="sorting">
                        <div class="form-group inline-label">
                            <div>
                                <select name="sorting" id="sorting">
                                    <option value="">Most Recently Used</option>
                                    <option value="">Most Recently Used</option>
                                    <option value="">Most Recently Used</option>
                                    <option value="">Most Recently Used</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-if="total > 0">
                        <strong>Showing</strong>
                        <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                        results
                    </div>
                    <b-table
                            class="list-table"
                            :sort-by.sync="sort_by"
                            :sort-desc.sync="sort_desc"
                            :fields="fields"
                            :items="recommendation"
                            show-empty
                    >
                        <template v-slot:empty="scope">
                            No recommendations created by you.
                        </template>
                        <template v-slot:cell(link)="data">
                            <a :href="$laravelRouter('recommended-vehicle.show', data.item.id)">Click here</a>
                        </template>
                    </b-table>
                    <b-pagination
                            v-if="total > 0"
                            :total-rows="total"
                            v-model="current_page"
                            :per-page="per_page"
                    ></b-pagination>

                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState } from 'vuex'
    import {objLookup} from '../../util/common'
    export default {
        created(){
            this.$store.dispatch('myrecommendations/getMyRecommendation', {
                sort_by: this.sortBy,
                sort_desc: this.sortDesc,
            });
        },
        data() {
            return {
                sort_by: 'created_at',
                sort_desc: true,
                selected_search: null,
                fields: [
                    {label: 'Created Date',      key: 'created_at'},
                    {label: 'Message',         key: 'message'},
                    {label: 'View Vehicle List',         key: 'link'},
                ]
            }
        },
        computed: {
            ...mapState({
                recommendation: state => state.myrecommendations.all,
                per_page: state => state.myrecommendations.per_page,
                from: state => state.myrecommendations.from,
                to: state => state.myrecommendations.to,
                last_page: state => state.myrecommendations.last_page,
                total: state => state.myrecommendations.total,
            }),
            current_page: {
                get(){
                    return this.$store.getters['myrecommendations/current_page'];
                },
                set(value){
                    return this.$store.dispatch('myrecommendations/getMyRecommendation', {page: value});
                }
            }
        },
        methods: {
            objLookup(obj, key){
                return objLookup(obj, key);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/MyRecommendations/MyRecommendationPage.vue